<template>
  <div class="side-modal-overlay" @click="$emit('close', title)">
    <div class="side-modal" @click.stop>
      <div class="modal-header">
        <div class="header-left">
          <button 
            v-if="showBackButton" 
            class="back-btn" 
            @click="$emit('go-back', form)"
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.25 13.5L6.75 9L11.25 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="title-group">
            <h2 class="modal-title">{{ title }}</h2>
            <p v-if="subTitle" class="modal-subtitle" v-html="subTitle"></p>
          </div>
        </div>
        <button class="close-btn" @click="$emit('close', title)">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 5L5 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 5L15 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <div class="modal-content">
        <slot name="content">content</slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SideModal",

  emits: ["close", "mounted", "go-back"],

  props: {
    title: { type: String, default: () => "", required: true },
    subTitle: {
      type: String,
      default: () => "",
      required: false,
    },
    form: {
      type: String,
      default: () => "",
      required: false,
    },
    showBackButton: {
      type: Boolean,
      default: () => true,
      required: false,
    },
    bgChange: {
      type: Boolean,
      default: () => false,
    },
  },

  mounted() {
    this.$emit("mounted", this.title);
    document.body.style.overflow = 'hidden';
  },

  beforeUnmount() {
    document.body.style.overflow = '';
  },
};
</script>

<style lang="scss" scoped>
.side-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  z-index: 50;
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.side-modal {
  position: fixed;
  top: 0;
  right: 0;
  width: 100%;
  max-width: 480px;
  height: 100vh;
  background: #FFFFFF;
  box-shadow: -8px 0 32px rgba(15, 23, 42, 0.12);
  display: flex;
  flex-direction: column;
  animation: slideIn 0.3s ease;

  @media (max-width: 480px) {
    max-width: 100%;
  }
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #E2E8F0;
  background: #FFFFFF;
  flex-shrink: 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: white;
    border-color: #4D84FF;
    color: #4D84FF;
  }
}

.title-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.modal-title {
  font-family: 'DM Sans', sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: #0F172A;
  margin: 0;
}

.modal-subtitle {
  font-family: 'DM Sans', sans-serif;
  font-size: 13px;
  color: #64748B;
  margin: 0;
}

.close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #64748B;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #FEF2F2;
    color: #EF4444;
  }
}

.modal-content {
  flex: 1;
  overflow-y: auto;
  background: #FFFFFF;
}
</style>
